/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ trialDays: NonNullable<unknown> }} Premium_Trial_FreeInputs */

const en_premium_trial_free = /** @type {(inputs: Premium_Trial_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your first ${i?.trialDays} days are free`)
};

const es_premium_trial_free = /** @type {(inputs: Premium_Trial_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tus primeros ${i?.trialDays} días son gratis`)
};

/**
* | output |
* | --- |
* | "Your first {trialDays} days are free" |
*
* @param {Premium_Trial_FreeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const premium_trial_free = /** @type {((inputs: Premium_Trial_FreeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Premium_Trial_FreeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_premium_trial_free(inputs)
	return en_premium_trial_free(inputs)
});